<template>
  <div>
    <h1>{{ $t("settings.role.roleEdit") }} {{ $route.params.id }}</h1>

    <div class="mt-3 elevation-12 grey lighten-4">
      <v-card>
        <v-card-text>
          <v-form lazy-validation ref="form" v-model="formValid">
            <v-row class="mt-1">
              <v-col
                ><h4>{{ $t("settings.role.usersHasRole") }} {{ $route.params.id }}</h4></v-col
              >
              <v-spacer></v-spacer>
              <v-col cols="3">
                <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="searchInside"></v-text-field>
              </v-col>
            </v-row>

            <v-data-table :headers="headers" :items="hasUsers" :search="searchInside">
              <template #item="props">
                <tr>
                  <td class="text-left">{{ props.item.login }}</td>
                  <td class="text-left">{{ props.item.name }}</td>
                  <td class="text-left">{{ props.item.surname }}</td>

                  <td class="text-left">
                    <v-tooltip bottom>
                      {{ $t("global.delete") }}
                      <template #activator="{on}">
                        <v-btn @click="removeUser(props.item.id)" icon v-on="on">
                          <v-icon>clear</v-icon>
                        </v-btn>
                      </template>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
              <template slot="no-data">
                <v-alert color="error" icon="warning">
                  {{ $t("settings.role.roleHasNoUsers") }}
                </v-alert>
              </template>
            </v-data-table>

            <v-row class="mt-5 md-2">
              <v-col
                ><h4>{{ $t("settings.role.availableUsers") }}</h4></v-col
              >
              <v-spacer></v-spacer>
              <v-col cols="3">
                <v-text-field :label="$t('global.search')" append-icon="search" hide-details single-line v-model="search"></v-text-field>
              </v-col>
            </v-row>

            <v-data-table :headers="headers" :items="availableUsers" :search="search">
              <template #item="props">
                <tr>
                  <td class="text-left">{{ props.item.login }}</td>
                  <td class="text-left">{{ props.item.name }}</td>
                  <td class="text-left">{{ props.item.surname }}</td>
                  <td class="text-left">
                    <v-tooltip bottom>
                      {{ $t("global.add") }}
                      <template #activator="{on}">
                        <v-btn @click="addUser(props.item.id)" icon v-on="on">
                          <v-icon>add</v-icon>
                        </v-btn>
                      </template>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-form>
        </v-card-text>
      </v-card>

      <v-card>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click.native="cancel()" color="blue darken-1" text>{{ $t("global.cancel") }}</v-btn>
          <v-btn :disabled="!formValid || $store.getters['Ajax/loading']" @click="save()" color="blue darken-1" text>{{ $t("global.save") }} </v-btn>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
export default {
  name: "SettingsRoleEditUsersView",
  data: () => ({
    groupList: [],
    search: null,
    searchInside: null,
    allUsers: [],
    formValid: true
  }),
  methods: {
    addUser(userId) {
      this.allUsers.find(user => user.id === userId).has_role = true;
    },
    removeUser(userId) {
      this.allUsers.find(user => user.id === userId).has_role = false;
    },
    save() {
      this.axios
        .post("settings/auth-admin/save-role-edit-users", {
          rolename: this.$route.params.id,
          users: this.allUsers
        })
        .then(resp => {
          if (resp.data.status === "OK") {
            this.$router.push("/settings/role");
          } else {
            console.log(resp.data);
          }
        })
        .catch(resp => {
          console.log(resp);
        });
    },
    cancel() {
      this.$router.push("/settings/role");
    }
  },
  computed: {
    headers() {
      return [
        { text: this.$t("user.login"), value: "login" },
        { text: this.$t("user.name"), value: "name" },
        { text: this.$t("user.surname"), value: "surname" },
        { text: "", value: "actions", sortable: false }
      ];
    },
    availableUsers() {
      const array = [];
      for (let authItem of this.allUsers.filter(item => item.has_role === false)) {
        array.push(authItem);
      }
      return array;
    },
    hasUsers() {
      const array = [];
      for (let authItem of this.allUsers.filter(item => item.has_role === true)) {
        array.push(authItem);
      }
      return array;
    }
  },
  created() {
    if (typeof this.$route.params.id !== "undefined") {
      this.axios.get("settings/auth-admin/get-role-edit-users?id=" + this.$route.params.id).then(resp => {
        this.allUsers = resp.data;
      });
    }
  }
};
</script>

<style></style>
